import {
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import {
  SnackbarSeverity,
  SnackbarMessageInfo,
  SnackbarMessageLine
} from './components/AppSnackbar'

export type SnackbarMessage = {
  messageLines: SnackbarMessageLine[]
  severity?: SnackbarSeverity
}

export type SnackbarState = {} & SnackbarMessageInfo

const initialState: SnackbarState = {
  open: false,
  messageLines: [],
  severity: 'info'
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbarMessages: (state, action: PayloadAction<SnackbarMessage>) => {
      state.open = true
      state.messageLines = action.payload.messageLines
      state.severity = action.payload.severity ?? 'info'
    },
    closeSnackbar: (state) => {
      state.open = false
    },
    resetSnackbar: (state) => {
      state.open = initialState.open
      state.messageLines = initialState.messageLines
      state.severity = initialState.severity
    }
  }
})

export const {
  setSnackbarMessages,
  resetSnackbar,
  closeSnackbar
} = snackbarSlice.actions

export const getSnackbarSelector = (state: RootState): SnackbarState => state.snackbar

export default snackbarSlice.reducer
